import styled from "styled-components";
import { Link as ReactLink } from "react-router-dom";
import {
  InputAdornment as MuiInputAdornment,
  CircularProgress as MuiCircularProgress,
  Snackbar as MuiSnackbar,
  Tooltip as MuiTooltip,
  Button as MuiButton,
  TablePagination as MuiTablePagination,
  TablePaginationProps,
} from "@material-ui/core";

// export { default as notify } from 'react-hot-toast';
// export { Toaster } from 'react-hot-toast';

export const Link = styled(ReactLink)`
  display: flex;
  align-items: center;
`;

export { ButtonAndIcon } from "./ButtonAndIcon";
export * from "./Dialogs";
export * from "./Form";
interface IIconProps {
  size?: number;
}
export const Icon = styled.img<IIconProps>`
  cursor: pointer;
  height: ${({ size }) => (size ? `${size}px` : "auto")};
  &:hover {
    opacity: 0.7;
  }
`;

export const InfoTitle = styled.span`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--grayLv3);
  margin-bottom: 5px;
`;

export const PillContainer = styled.div`
  height: 21px;
  width: 80px;
  margin-left: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: var(--success);
  color: var(--white);
  border-radius: 4px;
  font-size: 1.2rem;
`;

export const InputAdornment = styled(MuiInputAdornment)`
  &:hover {
    cursor: pointer;
    box-shadow: 2px 2px 5px darkgray;
  }
`;
interface TooltipProps {
  children: any;
  title: string;
}

export const Tooltip = ({ children, title, ...rest }: TooltipProps) => {
  return (
    <MuiTooltip
      title={<span style={{ fontSize: "12px" }}>{title}</span>}
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
};

export { default as Loading } from "./Loading";

export const FormLoginTitle = styled.div`
  font-weight: 600;
  font-size: 1.6rem;
  color: var(--grayLv1);

  @media (min-width: 1920px) {
    font-size: 1.6rem;
  }
`;

export { default as InfoCardNew } from "./InfoCardNew";

interface CircularProgressProps {
  color?: "primary" | "secondary" | "inherit";
}
export const CircularProgress = styled(
  MuiCircularProgress
)<CircularProgressProps>`
  &.MuiCircularProgress-colorPrimary {
    color: ${({ color }) => (color ? `var(--color-${color})` : "var(--white)")};
  }
`;

interface IButton {
  bgcolor?: "primary" | "secondary";
  fullWidth?: boolean;
  color?: "primary" | "secondary" | "inherit";
  disabled?: boolean;
}
const LoadingButtonContainer = styled(MuiButton)<IButton>`
  &.MuiButtonBase-root {
    background: ${({ bgcolor }) =>
      bgcolor === "secondary" ? "var(--black)" : "var(--orange)"};
    color: var(--white);
    width: 100%;
    height: 40px;

    @media (min-width: 960px) {
      width: ${({ fullWidth }) => (fullWidth ? "100%" : "155px")};
    }
  }
`;

export const LoadingButton = (props: IButton) => {
  return (
    <LoadingButtonContainer
      bgcolor={props.bgcolor}
      fullWidth={props.fullWidth}
      disabled={props.disabled}
    >
      <CircularProgress
        color={props.color}
        style={{ height: "32px", width: "32px" }}
      />
    </LoadingButtonContainer>
  );
};

export const Snackbar = styled(MuiSnackbar)`
  & .MuiSnackbarContent-root {
    min-height: 60px;
  }

  & .MuiSnackbarContent-message {
    font-size: 1.6rem;
  }
`;

export * from "./tables";
export { default as ArrowBackPage } from "./ArrowBackPage";

export * from "./PageHeader";

interface TablePaginationOwnProps extends TablePaginationProps<any> {
  component: string;
}

export const TablePagination = styled(
  MuiTablePagination
)<TablePaginationOwnProps>`
  & .MuiTablePagination-caption {
    font-size: 1.2rem;
  }

  & .MuiTablePagination-input {
    font-size: 1.2rem;
  }

  & .MuiSelect-select.MuiSelect-select {
    border-radius: 20px;
  }

  & .MuiSelect-icon {
    right: 4px;
  }
`;

export * from "./SearchInput";
export * from "./ModulockerTemplate";
export { default as ToastContainer } from "./ToastContainer";
export * from "./InfoField";
export * from "./InfoFieldGrid";
